export const FOLLOWER_LIST_ATTEMPT = "FOLLOWER_LIST_ATTEMPT";
export const FOLLOWER_LIST_SUCCESS = "FOLLOWER_LIST_SUCCESS";
export const FOLLOWER_LIST_FAILED = "FOLLOWER_LIST_FAILED";
////////////
export const FOLLOWER_MORELIST_ATTEMPT = "FOLLOWER_MORELIST_ATTEMPT";
export const FOLLOWER_MORELIST_SUCCESS = "FOLLOWER_MORELIST_SUCCESS";
export const FOLLOWER_MORELIST_FAILED = "FOLLOWER_MORELIST_FAILED";